import './index.scss';

import '@qnpm/hysdk';
import '@qnpm/hysdk-qunar';
hysdk.config({});
import {Provider, inject} from 'mobx-react';
import store from './store';
import Scroller from '$components/Scroller';
import TopVideo from './components/TopVideo';
import Products from './components/Products';
import Hotels from './components/Hotels';
import Sights from './components/Sights';
import Introductions from './components/Introductions';
import VideoModal from './components/VideoModal';
import Bottom from './components/Bottom';

@inject(({store}) => {
    return {
        init: store.init
    };
})
class App extends React.Component {
    componentDidMount() {
        this.props.init();
    }

    render() {
        return (
            <Scroller className="scroller">
                <div className="header"></div>
                <TopVideo />
                <Products />
                <Hotels />
                <Sights />
                <Introductions />
                <Bottom />
                <VideoModal />
            </Scroller>
        );
    }
}

ReactDOM.render(<Provider store={store}><App/></Provider>, document.querySelector('#app'));
ShareSDK.config({
    title: '体验阿布扎比，找到你的节奏',
    text: '阿布扎比X去哪儿旗舰馆',
    desc: '阿布扎比X去哪儿旗舰馆',
    imgUrl: 'https://s.qunarzz.com/vacation_tuan/2023/abudhabi/share.png',
    link: location.href
});